module.exports = __webpack_public_path__ + "static/img/bg-cscenter-safeguard.0bd446fb.jpg";